'use client';

import { Image } from '@bytel/trilogy-react-ts';

import { PlanType } from '@app-types/product';

import { classNames } from '@helpers/classnames';

export function IconContainer({ show5GPicto, baseProduct }: { show5GPicto?: boolean; baseProduct?: PlanType }) {
    const iconsList = [
        {
            image: 'https://www.bouyguestelecom.fr/assets/media/original/image/CMS/ecommerce/byou/prime_Logo.svg',
            imageWidth: 55,
            id: 'prime',
            classnames: 'mt-2 me-2',
            seo: 'amazon prime',
        },
        {
            classIcon: 'air-travel',
            id: 'roaming',
            classnames: 'mt-0',
            seo: 'Itinérance',
        },
        {
            image: 'https://www.bouyguestelecom.fr/assets/media/original/image/CMS/ecommerce/byou/serviceMax-w.svg',
            imageWidth: 55,
            id: 'serviceMax',
            classnames: 'mt-2 me-2',
            seo: 'service max',
        },
        {
            classIcon: '5g',
            id: '5g',
            classnames: 'is-medium mt-n3',
            seo: '5G',
        },
    ];

    return (
        <div className='is-absolute icon-holder'>
            {iconsList.map((item) => {
                if (
                    !baseProduct ||
                    (item.id === '5g' && (!show5GPicto || baseProduct.serviceMax)) ||
                    (item.id === 'prime' && !baseProduct.prime) ||
                    (item.id === 'roaming' && !baseProduct.roaming) ||
                    (item.id === 'serviceMax' && !baseProduct.serviceMax)
                ) {
                    return null;
                }

                return (
                    <div id={item.id} key={item.id}>
                        <span className={classNames('icon is-small', item.classnames)}>
                            {item.classIcon ? (
                                <i
                                    className={`tri-${item.classIcon}`}
                                    aria-hidden='true'
                                    aria-label={item.seo}
                                    role='icon'
                                />
                            ) : (
                                <Image src={item.image as string} alt={item.seo} width={55} height={20} />
                            )}
                            <span className='is-hidden'>{item.seo}</span>
                        </span>
                    </div>
                );
            })}
        </div>
    );
}
